import { withCompInfo } from '@wix/editor-elements-integrations'
import { TinyMenuCSSVars, TinyMenuDefinition } from './TinyMenu'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { isFixedPosition } from '@wix/editor-elements-common-utils'
import type { FixedPositionItemLayout } from '@wix/thunderbolt-becky-types'

export const WIX_ADS_HEIGHT = 38

const isClassicSkin = (skin: TinyMenuDefinition['skin']) => skin === 'TinyMenuSkin'

export const css = withCompInfo<TinyMenuCSSVars, TinyMenuDefinition>()(
	[
		'compLayout',
		'styleProperties',
		'skin',
		// @ts-expect-error
		'siteWidth',
		'siteColors',
		// @ts-expect-error
		'shouldShowFreemiumBanner',
		'compSingleLayout',
		'isOneDocMigrated',
	],
	({
		compLayout,
		styleProperties,
		skin,
		// @ts-expect-error - remove once siteWidth is added to CompInfo
		siteWidth,
		siteColors,
		// @ts-expect-error
		shouldShowFreemiumBanner,
		compSingleLayout,
		isOneDocMigrated,
	}) => {
		const getMarginLeft = (): number => {
			const marginLeftObj = (compSingleLayout?.itemLayout as FixedPositionItemLayout)?.left
			return marginLeftObj?.type === 'px' ? marginLeftObj.value : 0
		}

		const strokeWidth = styleProperties.strokewidth
		const xPosition = isOneDocMigrated ? getMarginLeft() : compLayout.x
		const isFixed = isOneDocMigrated ? isFixedPosition(compSingleLayout) : compLayout.fixedPosition

		const btnPaddingTop = strokeWidth && {
			'--btn-padding-top': `${((parseInt(strokeWidth, 10) % 2) * -1 + 1) / 2}px`,
		}

		const buttonMarginTop = isFixed &&
			shouldShowFreemiumBanner && {
				'--btn-margin-top': `${WIX_ADS_HEIGHT}px`,
			}

		const containerPaddingTop = shouldShowFreemiumBanner && {
			'--container-padding-top': `${WIX_ADS_HEIGHT}px`,
		}

		const rootStyles = isFixed && {
			'--root-z-index': 50,
			'margin-left': `calc(50% - ${siteWidth ? siteWidth / 2 : 0}px)`,
			...(!isOneDocMigrated && {
				position: 'fixed',
				top: `${compLayout.y}px`,
				left: `${compLayout.x}px`,
			}),
		}

		const brightnessParams = colorApi.getBrightnessCSSVars<
			Pick<TinyMenuCSSVars, '--counter-color-mutated-brightness'>
		>({
			paramName: 'counterColor',
			mutatedParamName: 'counter-color',
			fallbackName: 'txt',
			alpha: 2,
			siteColors,
			styleProperties,
		})

		const containerMarginLeft = isClassicSkin(skin) && {
			'--container-margin-left': xPosition ? `-${xPosition}px` : 0,
		}

		const fixInvalidBg = styleProperties.bg === '###' && {
			'--bg': 'var(--color_15)',
		}

		return {
			...brightnessParams,
			...btnPaddingTop,
			...buttonMarginTop,
			...containerPaddingTop,
			...containerMarginLeft,
			...rootStyles,
			...fixInvalidBg,
		}
	}
)
